import {
  ArrowRightAlt,
  ArrowUpward,
  Facebook,
  Instagram,
  Language,
  LinkedIn,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Divider,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import carfaxLogo from "../assets/carfax-footer-logo.svg";
import footerLogo from "../assets/footer-logo.svg";
import omvicLogo from "../assets/omvic-logo.svg";

const Footer = () => {
  const { t } = useTranslation("footer");
  
  // Define the useful links with their translation keys
  const usefulLinks = [
    { key: "termsAndConditions", href: "#" },
    { key: "cookiesPolicy", href: "#" },
    { key: "aboutUs", href: "#" },
    { key: "faq", href: "#" },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "primary.main",
        color: "text.secondary",
        p: 4,
        pt: 6,
      }}
    >
      <Box
        sx={{
          width: "90vw",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          mx: "auto",
        }}
      >
        {/* Left Section */}
        <Box
          sx={{ maxWidth: 400 }}
          display={"flex"}
          flexDirection={"column"}
          gap={2}
        >
          <img src={footerLogo} />
          <Typography
            variant="subtitle1"
            color="text.secondary"
            sx={{ mt: 1, opacity: 0.8 }}
          >
            {t("footerDesc")}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
            <img
              src={omvicLogo}
              alt="OMVIC"
              style={{ height: "4rem", marginRight: "0.5rem" }}
            />
            <img src={carfaxLogo} alt="CARFAX" style={{ height: "4rem" }} />
          </Box>
          {/* Contact Us Button - Full Width */}
          <Button
            variant="outlined"
            sx={{
              mt: 2,
              width: "100%",
              borderRadius: 20,
              color: "white",
              borderColor: "white",
              justifyContent: "space-between",
              px: 3,
              "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
            }}
            endIcon={<ArrowRightAlt />}
          >
            {t("contactUs")}
          </Button>
        </Box>

        {/* Middle Section - Links */}
        <Box sx={{ textAlign: "left" }}>
          <Typography variant="h5" mb={2.5} color="text.secondary">
            {t("usefulLinks")}
          </Typography>
          {usefulLinks.map((link) => (
            <Typography key={link.key} color="text.secondary" mb={2}>
              <Link
                href={link.href}
                sx={{
                  color: "white",
                  textDecoration: "none",
                  "&:hover": { textDecoration: "underline", color: "white" },
                }}
              >
                {t(link.key)}
              </Link>
            </Typography>
          ))}
        </Box>

        {/* Right Section - Contact Info */}
        <Box sx={{ textAlign: "left" }}>
          {/* Back to Top Button */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              mb: 6,
            }}
          >
            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{ mr: 1 }}
            >
              Back to Top
            </Typography>
            <IconButton
              sx={{
                border: "1px solid white",
                borderRadius: "50%",
                color: "white",
                width: 32,
                height: 32,
              }}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <ArrowUpward fontSize="small" />
            </IconButton>
          </Box>
          <Typography sx={{ mb: 1 }} color="text.secondary">
            {t("address")}
          </Typography>
          <Typography variant="subtitle2" mb={2} color="text.secondary">
            20-4544 Dufferin St, North York M3H 5X2
          </Typography>
          <Typography sx={{ mb: 1 }} color="text.secondary">
            {t("contactUs")}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 2, fontSize: "1.2rem" }}
          >
            647-689-6208
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Ontario
          </Typography>

          {/* Social Icons */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            {[Facebook, Instagram, Language, LinkedIn].map((Icon, index) => (
              <IconButton
                key={index}
                sx={{
                  color: "white",
                  border: "1px solid",
                  borderRadius: "50%",
                  borderColor: "white",
                  ml: 1,
                }}
              >
                <Icon />
              </IconButton>
            ))}
          </Box>
        </Box>
      </Box>

      {/* Copyright Section */}
      <Divider sx={{ backgroundColor: "white", opacity: 0.3, mt: 4, mb: 2 }} />
      <Typography
        variant="body2"
        sx={{ textAlign: "center", fontSize: "0.8rem" }}
        color="text.secondary"
      >
        All Copyrights © reserved 2024 - Car Chaser
      </Typography>
    </Box>
  );
};

export default Footer;